import { Company } from '@lx/shared/types';
import { getCompany } from './get-company.function';

const COMPANY_HEADER_MAP = {
  kaplan: 'KIL',
  alpadia: 'ALP',
  esl: 'ESL',
  'positively-languages': 'KIL', // TODO once BE is ready, we will have to change this to 'PL'
} satisfies Record<Company, 'KIL' | 'ALP' | 'ESL'>;

export const getCompanyHeader = (company: Company = getCompany()) => COMPANY_HEADER_MAP[company];
